import { Component, OnInit } from '@angular/core';
import {TranslationService} from '../utils/translate.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  constructor(public translate: TranslationService) { }

  ngOnInit() {
  }
}
